module.exports = __webpack_public_path__ + "img/index-logo.204d558d.png";